export enum BackendModelKey {
   user = 'App\\Models\\User',
   team = 'App\\Models\\Team',
   squadFilter = 'App\\Models\\SquadFilter',
   tenant = 'App\\Models\\Tenant',
   board = 'App\\Models\\Board',
   pool = 'App\\Models\\Pool',
   candidate = 'App\\Models\\Candidate',
   company = 'App\\Models\\Company',
}
